import { CommunicationChannel } from '../../../../pure-js/enums/Communication'
import { OrgRole } from '../../../../pure-js/types/OrganizationMembership'
import {
  CHANNEL_OPT_OUT_TOGGLES,
  getCommunicationCategoriesForAudiences
} from '../../../../pure-js/libs/communicationCategories'
import { SettingsFieldType, type SettingsField, type SettingsSectionSchema } from '../settings/types'

export const COMMUNICATION_SETTINGS_SECTION_ID = 'communication'

// Field-key prefixes so the mapper can route a flat value back to the right place.
export const categoryFieldKey = (category: string): string => `category:${category}`
export const channelFieldKey = (channel: string): string => `channel:${channel}`

const CHANNEL_LABEL_KEYS: Partial<Record<CommunicationChannel, { labelKey: string; descriptionKey: string }>> = {
  [CommunicationChannel.SMS]: {
    labelKey: 'settings.communication.channels.sms.label',
    descriptionKey: 'settings.communication.channels.sms.description'
  }
}

// Categories for the user's audiences + (gamer-only) SMS channel toggle. Toggles read
// positively ("Receive X"); the mapper inverts to opt-out flags.
export const buildCommunicationSettingsSchema = (audiences: OrgRole[]): SettingsSectionSchema => {
  const channels = audiences.includes(OrgRole.GAMER) ? CHANNEL_OPT_OUT_TOGGLES : []

  const fields: SettingsField[] = [
    ...getCommunicationCategoriesForAudiences(audiences).map<SettingsField>((def) => ({
      key: categoryFieldKey(def.category),
      type: SettingsFieldType.TOGGLE,
      labelKey: def.labelKey,
      descriptionKey: def.descriptionKey
    })),
    ...channels.map<SettingsField>((channel) => ({
      key: channelFieldKey(channel),
      type: SettingsFieldType.TOGGLE,
      labelKey: CHANNEL_LABEL_KEYS[channel]?.labelKey ?? channel,
      descriptionKey: CHANNEL_LABEL_KEYS[channel]?.descriptionKey
    }))
  ]

  return {
    id: COMMUNICATION_SETTINGS_SECTION_ID,
    titleKey: 'settings.communication.title',
    descriptionKey: 'settings.communication.description',
    fields
  }
}
